module.exports = __webpack_public_path__ + "static/media/Backdrop_RNG.93f1b1ea.png";